export default {
  'meta': {
    'langName': 'FRANCAIS',
    'lang': 'Français'
  },
  'title': 'RAPPEL PRODUIT  TROTINETTE ELECTRIQUE SD500E ou MD500E de la marque BTWIN',
  'description': 'Bonjour,\n\nVous avez effectué l’achat d’une trottinette électrique SD 500E ou MD500E de la marque BTWIN  et nous vous en remercions.  \n\nVotre sécurité étant notre priorité, veuillez prendre connaissance des informations suivantes. \n\nMalgré des procédures rigoureuses de contrôle qualité, nous avons identifié que les trottinettes électriques SD500E et MD500E de la marque BTWIN présentent un défaut de sécurité. Un usage intensif peut conduire à l\'apparition d\'une fissure à la jonction du cadre et de la potence. Ce défaut peut entraîner la rupture de cette jonction, engendrant un risque de chute pour l\'utilisateur. \n\nNous vous proposons de répondre aux questions suivantes afin de vous apporter la solution de mise en sécurité de votre produit.\n\nNous nous excusons pour la gêne occasionnée et vous remercions de votre confiance.\n\nDECATHLON',
  'emailConfirmation': {
    'title': 'Tout d’abord, pouvez-vous nous confirmer votre adresse mail et pays de résidence :'
  },
  'fields': {
    'country': 'Pays',
    'address': 'Adresse mail',
    'email': 'Adresse mail',
    'phonePrefix': 'Indicatif numéro de téléphone',
    'phone': 'Numéro de Téléphone',
    'validations': {
      'phoneOrEmail': 'Merci de renseigner au minimum une adresse email OU un numéro de téléphone',
      'email': 'Veuillez introduire une adresse email valide',
      'phone': 'Veuillez introduire un numéro de téléphone valide'
    },
    'firstName': 'Nom',
    'lastName': 'Prénom',
    'deliveryAddress': 'Adresse de livraison',
    'additionalAddress': 'Complément d\'adresse',
    'city': 'Ville',
    'zip': 'Code postal ',
    'readConfirmation': 'J\'ai vérifié mes coordonnées, pris connaissance des informations et je m\'engage à les respecter.',
    'choose': 'Choisir',
    'required': 'Ce champ est requis'
  },
  'ownerCheck': {
    'title': 'Etes-vous toujours en possession d’une ou plusieurs trottinettes électriques SD500E et MD500E de la marque BTWIN?'
  },
  'yes': 'OUI',
  'no': 'NON',
  'ownerChanged': {
    'title': 'Avez-vous les coordonnées du ou des propriétaires actuels ?',
    'confirmation': 'M./Mme.\n\nNous vous remercions pour votre participation à cette démarche qualité. \n\nNous nous excusons pour la gêne occasionnée et vous remercions de votre confiance.\n\nDECATHLON'
  },
  'recall': {
    'title': 'Indiquez nous la quantité de trottinettes électriques SD500E et MD500E de la marque BTWIN',
    'descriptionSd500': 'trottinettes électriques  SD500E',
    'descriptionEmd500e': 'trottinettes électriques  MD500E ',
    'modelNumberHelp': 'Vous trouverez la référence du modèle (SD500E ou MD500E) en dessous de votre trottinette, comme illustré ici',
    'quantity': 'Quantité',
    'confirmation': 'Merci d’avoir répondu à ce formulaire, votre demande a bien été enregistrée. \n\nNous vous communiquerons, sous 20 jours maximum, la date à partir de laquelle vous pourriez effectuer la reparation.\n\nNous vous souhaitons une bonne journée\n\nDECATHLON'
  },
  'repair': {
    'title': 'Réparation par vos soins',
    'description': '\n Nous vous demandons de ne plus l’utiliser.\n\nUn kit de réparation et notice vous seront envoyés à votre domicile afin que vous puissiez sécuriser votre trottinette. Ce kit vous sera envoyé à titre gratuit, son montage est simple et rapide.\n\nSuite à la prise de vos informations nous allons vous contacter, sous 20 jours maximum, pour définir la date à partir de laquelle la réparation sera possible. Sachez que tout sera mis en œuvre pour réduire ces délais afin de vous satisfaire.',
    'videoLink': 'Lien de la vidéo de montage',
    'kitLabel': 'Kit complet de réparation',
    'docLabel': 'Notice de réparation',
    'callToAction': 'Cliquez ici pour recevoir le kit de réparation gratuitement'
  },
  'repairRequest': {
    'title': 'Merci de saisir les informations suivantes pour recevoir votre kit de reparation :'
  },
  'form': {
    'submit': 'Suivant'
  },
  'status': 'Translation validated by SPORT'
} as const
